import styled from 'styled-components';

export const Content = styled.div`
    width: 100vw;
    min-height: 50vh;
    background: ${({ theme }) => theme.colors.fixed.white};
`;
